import { render, staticRenderFns } from "./DoctorRegisterRecordModal__Style#Drawer.vue?vue&type=template&id=ae81efd6&scoped=true&"
import script from "./DoctorRegisterRecordModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterRecordModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterRecordModal__Style#Drawer.vue?vue&type=style&index=0&id=ae81efd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae81efd6",
  null
  
)

export default component.exports